import { render, staticRenderFns } from "./userYulian.vue?vue&type=template&id=205783b4&scoped=true&"
import script from "./userYulian.vue?vue&type=script&lang=js&"
export * from "./userYulian.vue?vue&type=script&lang=js&"
import style0 from "./userYulian.vue?vue&type=style&index=0&id=205783b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205783b4",
  null
  
)

export default component.exports